import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { Globals } from 'src/app/service/global';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { AnyTxtRecord } from 'dns';
import { data } from 'jquery';
import { FreeFormAgendaService } from 'src/app/service/free-form-agenda.service';
import { environment } from 'src/environments/environment';
import { AttendeeDialogComponent } from '../attendee-dialog/attendee-dialog.component';
import { FreeFormCommonService } from 'src/app/service/free-form-common.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { isString } from '@ng-bootstrap/ng-bootstrap/util/util';
import { UtilityService } from 'src/app/service/utility.service';
import { FreeFormMinutesService } from 'src/app/service/free-form-minutes.service';
const moment = _rollupMoment || _moment;
 
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'MMM DD, yyyy',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};
@Component({
  selector: 'app-agenda-task-edit-dialog',
  templateUrl: './agenda-task-edit-dialog.component.html',
  styleUrls: ['./agenda-task-edit-dialog.component.css'],
  providers: [{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
 
  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    , DatePipe]
})
export class AgendaTaskEditDialogComponent implements OnInit {
  taskDetails: any;
  addTaskToUser = false;
  taskStatusList: any = [];
  dueDate: any;
  setDueDate = ""
  ownerName: any;
  //taskDueDate = new FormControl();
  newDueDate = new UntypedFormControl();
  newStatus =new UntypedFormControl();
  disableUpdate: any;
  assignedToValues: any = [];
  testAssign:any=[];
  taskUserId: any;
  reAssignUserId: any;
  reAssignSecUserId: any;
  newreAssignSecUserId: any=[];
  showAddTaskAgain = false;
  deleteArray = false;
  AssignedreturnValue:any=[];
  convertedDueDate: any;
  testingArray : any = [{
    "actionItemActualComplDate": "",
    "complDateStr": "",
    "fkCodelstStatus": 16,
    "fkSecUserOwner": "",
    "ismailsent": "",
    "ownerName": "",
  }];
 
  //UI Team change variable
 
  newAssignedTo : any;
  newReAssign : any;
 
  showOtherRow = false;
  assignerName = "";
  dateContent = "";

  quillConfig: any = {
    letter: false,
    modules: {
      toolbar: false
    },
    placeholder: ' ',
    theme: 'snow',
  };
  taskContent : any;
  
  constructor(public dialogRef: MatDialogRef<AgendaTaskEditDialogComponent>,public commonMinService:FreeFormMinutesService,private utilService:UtilityService,private dialog :MatDialog,private commonAgService: FreeFormAgendaService, private datepipe: DatePipe, private matDialogRef: MatDialogRef<AttendeeDialogComponent>, private globals: Globals, private freeformagenda: FreeFormAgendaService, private commonService: FreeFormCommonService, @Inject(MAT_DIALOG_DATA) data: any) {
    this.taskStatusList = this.globals.globaltaskStatusList;
    this.taskDetails = data;
    this.setData();
  }
  taskEdit = new UntypedFormGroup({
    assignedToUpdate: new UntypedFormControl(''),
    assignedTo: new UntypedFormControl(''),
    dueDate: new UntypedFormControl(''),
    dueDateStr: new UntypedFormControl(''),
    meetingId: new UntypedFormControl(''),
    minutesId: new UntypedFormControl(''),
    taskTitle: new UntypedFormControl(''),
    agendaId: new UntypedFormControl(''),
    guestOwnerName: new UntypedFormControl(''),
    isPrivate: new UntypedFormControl(''),
    noteTypeId: new UntypedFormControl(''),
    noteTypeCode: new UntypedFormControl(''),
    taskId: new UntypedFormControl(''),
    taskEditFrom: new UntypedFormControl(''),
    userId: new UntypedFormControl(''),
    visitorTimeZone: new UntypedFormControl(''),
    deletedFlag: new UntypedFormControl(''),
    noteDescription :new UntypedFormControl(''),
    taskCommonStatus:new UntypedFormControl('')
  })
 
  ngAfterViewInit() {
    this.commonMinService.activateAllCkeditor('taskTitles');
  }
  //UI Team changes
  AddOtherRow(index: any) {
    var assignedTo = this.commonAgService.addTasktoUser();
      var newAssignedToJson = {
        "fkCodelstStatus": 16,
        "ownerName": "",
        "fkSecUserOwner": "",
      };
      this.assignedToValues.push(newAssignedToJson);
    this.disableUpdate = index;
    this.addTaskToUser = true;
    // if (this.assignerName != '' || this.taskDetails.taskData.actionItemOwner[index].ownerName != '') {
      this.taskDetails.taskData.actionItemOwner.push({
        "actionItemActualComplDate": "",
        "complDateStr": "",
        "fkCodelstStatus": 16,
        "fkSecUserOwner": "",
        "ismailsent": "",
        "ownerName": "",
      })
      this.assignerName = ''   
  }
 
  assignerNames(e: any) {
    this.assignerName = e.target.value
  }
 
  deleteRow(index: any) {
    this.taskDetails.taskData.actionItemOwner.splice(index, 1)
   this.assignedToValues.splice(index,1)
   this.deleteArray=true;
 
  }
 
  // UI team changes
  addTaskOpener() {
    this.showAddTaskAgain = !this.showAddTaskAgain
  }
  //set formcontrol values
  setData() {
    if(this.taskDetails.taskData.actionItemOwner != null){
    this.taskDetails.taskData.actionItemOwner.forEach((taskEle: any, taskIndex: any) => {
      var assignedToJson = {
        "fkCodelstStatus": taskEle.fkCodelstStatus,
        "ownerName": taskEle.ownerName,
        "fkSecUserOwner": taskEle.fkSecUserOwner,
      }
      this.assignedToValues.push(assignedToJson);
 
    });
  }
  if(this.taskDetails.taskData.actionItemOwner==null){
    this.taskDetails.taskData.actionItemOwner= [];
  }
    if(this.taskDetails.taskData.actionItemOwner.length==0){
      this.taskDetails.taskData.actionItemOwner.push({
        "actionItemActualComplDate": "",
        "complDateStr": "",
        "fkCodelstStatus": this.taskDetails.taskData.status,
        "fkSecUserOwner": "",
        "ismailsent": "",
        "ownerName": "",
      })
      var assignedToJson = {
        "fkCodelstStatus": this.taskDetails.taskData.status,
        "ownerName": '',
        "fkSecUserOwner": '',
      }
      this.assignedToValues.push(assignedToJson);
 
    }
  
 
    if (this.taskDetails.taskData.assignedTo == null || this.taskDetails.taskData.assignedTo == '' || this.taskDetails.taskData.assignedTo == 'undefined') {
      this.taskEdit.controls['assignedToUpdate'].setValue("");
    } else {
      this.taskEdit.controls['assignedToUpdate'].setValue("");
    }
    if (this.taskDetails.taskData.dueDate == null || this.taskDetails.taskData.dueDate == '' || this.taskDetails.taskData.dueDate == 'undefined') {
      this.taskEdit.controls['dueDate'].setValue(this.setDueDate);
    } else {
      var curSysDate = new Date(this.taskDetails.taskData.dueDateStr);
    var nowUtcDate = curSysDate.getTime() + (curSysDate.getTimezoneOffset() * 60000);//current utc date with time
    var nowDate = new Date(nowUtcDate + (3600000*(this.globals.vTimeZoneIntOffset)));	
    nowDate.setHours(0,0,0,0);
    this.convertedDueDate = nowDate;
    this.taskEdit.controls['dueDate'].setValue(nowDate);
    this.taskEdit.controls['dueDateStr'].setValue(this.taskDetails.taskData.dueDateStr);
    }
    this.taskEdit.controls['agendaId'].setValue(this.taskDetails.taskData.agendaId);
    this.taskEdit.controls['assignedTo'].setValue(JSON.stringify(this.assignedToValues));
    this.taskEdit.controls['taskTitle'].setValue(this.taskDetails.taskData.taskTitle);
    this.taskEdit.controls['deletedFlag'].setValue(this.taskDetails.taskData.deletedFlag);
    this.taskEdit.controls['isPrivate'].setValue(this.taskDetails.taskData.isPrivate);
    this.taskEdit.controls['meetingId'].setValue(this.taskDetails.taskData.meetingId);
    this.taskEdit.controls['minutesId'].setValue(this.taskDetails.taskData.minutesId);
    this.taskEdit.controls['noteTypeCode'].setValue(this.taskDetails.taskData.noteTypeCode);
    this.taskEdit.controls['noteTypeId'].setValue(this.taskDetails.taskData.noteTypeId);
    this.taskEdit.controls['taskEditFrom'].setValue("MT");
    this.taskEdit.controls['taskId'].setValue(this.taskDetails.taskData.taskId);
    this.taskEdit.controls['userId'].setValue(this.globals.userId);
    this.taskEdit.controls['taskCommonStatus'].setValue(this.taskDetails.taskData.status)
    this.taskEdit.controls['visitorTimeZone'].setValue(this.globals.vTimeZone);
    this.taskEdit.controls['noteDescription'].setValue(this.taskDetails.taskData.noteDescription);
    this.newStatus.setValue(this.taskDetails.taskData.status);
    this.newDueDate.setValue(this.taskDetails.taskData.dueDate)
  }
 
  ngOnInit(): void {
  }
  //method is used to update task status
  taskStatusUpdate(e: any) {
    var objIndex = this.assignedToValues.findIndex(((obj: { fkSecUserOwner: any; }) => obj.fkSecUserOwner == this.taskUserId));
    this.assignedToValues[objIndex].fkCodelstStatus = e.value;
    this.taskEdit.controls['taskCommonStatus'].setValue(e.value)
  }
  //method is used to get the current fksecuserID
  taskUser(e: any) {
    this.taskUserId = e;
  }
  triggered(){
    this.dialog.open(ConfirmDialogComponent, {
      data: {
        dialogTitle : "Confirmation",
        dialogContent : "Please confirm before changing due date"
      },
      }).afterClosed().subscribe(response => {
        let confirmRes = response
        if(confirmRes){
          this.dueDate = this.datepipe.transform(this.taskEdit.controls['dueDate'].value, "MMM dd, YYYY");
          this.taskEdit.controls['dueDateStr'].setValue(this.dueDate);
        }
        else{
          this.taskEdit.controls['dueDate'].setValue(this.convertedDueDate);
          this.dueDate = this.datepipe.transform(this.taskEdit.controls['dueDate'].value, "MMM dd, YYYY");
          this.taskEdit.controls['dueDateStr'].setValue(this.dueDate);
        }
       
      });
  }
  //method is used to update the task edit dialog box
  updateTaskDialog() {
    this.taskEdit.controls['taskTitle'].setValue(this.taskContent);
    this.taskEdit.controls['minutesId'].setValue(String(this.taskEdit.controls['minutesId'].value)?.replace("T_", ""));
    this.assignedToValues.forEach((element:any,index:number) => {
      if(element.fkSecUserOwner=="" && this.taskDetails.taskData.actionItemOwner.length>index ){
        this.assignedToValues[index].fkSecUserOwner =this.taskDetails.taskData.actionItemOwner[index].fkSecUserOwner
        this.assignedToValues[index].ownerName =this.taskDetails.taskData.actionItemOwner[index].ownerName
      }
       if(element.fkSecUserOwner=="" && this.taskDetails.taskData.actionItemOwner.length<index){
          this.assignedToValues.splice(index,1)
        }
    });
    if(this.assignedToValues[0].ownerName.length != 0){
    this.taskEdit.controls['assignedTo'].setValue(JSON.stringify(this.assignedToValues));
    }
  else{
 	 this.taskEdit.controls['assignedTo'].setValue("[]");
  }

    var assignedToUpdate = this.iterateAssignedToUpdate(this.taskDetails.taskData.actionItemOwner);
    this.taskEdit.controls['assignedToUpdate'].setValue(assignedToUpdate);
    //update method is called
    var taskResponse = this.freeformagenda.updateTaskFromDialog(this.taskEdit.value,this.taskDetails.curTaskUiInfo);
    this.matDialogRef.close({taskResponse,data:'Y'});
 
  }
  iterateAssignedToUpdate(actionItemOwner:any){
    var assignedTo = "";
    actionItemOwner.forEach((element:any) => {
      assignedTo += element.fkSecUserOwner + ",";
    });
    assignedTo = this.utilService.removeLastString(assignedTo, ",");
    return assignedTo;
  }
 
  //used to get the Reassigned user Id
  reassignTask(event: any, obj: any,index:any) {
   var object = this.commonAgService.loaTaskEditAssignandAgEditPresenter(true, 'AGTASKEDT', obj).then((id:any)=>{   
    this.assignedToValues[index].fkSecUserOwner=(id.userId)
    this.assignedToValues[index].ownerName=(id.username)
   });
  }
  clearAttendee(index:any,event:any){
    if(event.target.value==0){
      this.assignedToValues[index].fkSecUserOwner=''
      this.assignedToValues[index].ownerName=''
    }
  }
 
  getAssignedTo(e : any){
    this.newAssignedTo = e.target.value
  }
 
  getReAssignedTo(e : any){
    this.newReAssign = e.target.value
  }
 
  getDuedate(e : any){
    this.newDueDate = e.target.value
  }
 
  AddNewRow() {  
     var assignedTo = this.commonAgService.addTasktoUser();
    if (assignedTo != undefined && assignedTo != "") {
      var newAssignedToJson = {
        "fkCodelstStatus": this.newStatus.value,
        "ownerName": assignedTo.username,
        "fkSecUserOwner": assignedTo.userId,
      };
      this.assignedToValues.push(newAssignedToJson);
      this.taskEdit.controls['assignedTo'].setValue(JSON.stringify(this.assignedToValues));
    }
    this.testingArray.unshift({
      "actionItemActualComplDate": "",
      "complDateStr": this.newDueDate,
      "fkCodelstStatus": 16,
      "fkSecUserOwner": this.newReAssign,
      "ismailsent": "",
      "ownerName": this.newAssignedTo,
    })
    
  }
  deleteNewRow(indexOfelement : any){
    this.testingArray.splice(indexOfelement, 1)
  }
  updateNewTaskDialog(){
    var assignedTo = this.commonAgService.addTasktoUser();
    if (assignedTo != undefined && assignedTo != "") {
      var newAssignedToJson = {
        "fkCodelstStatus": this.newStatus.value,
        "ownerName": assignedTo.username,
        "fkSecUserOwnertaskEdit": assignedTo.userId,
      };
      this.assignedToValues.push(newAssignedToJson);
      this.taskEdit.controls['assignedTo'].setValue(JSON.stringify(this.assignedToValues));
    }
    var dueDate = this.datepipe.transform(this.newDueDate.value, "MMM dd, YYYY");
    this.taskEdit.controls['dueDateStr'].setValue(dueDate);
    if(this.addTaskToUser){
      
    }
    if(this.taskEdit.controls['assignedTo'].value == '[]'){
    this.taskEdit.controls['taskCommonStatus'].setValue(this.newStatus.value)
    }else{
      this.taskEdit.controls['taskCommonStatus'].setValue(null)
    }
 
    this.taskEdit.controls['taskTitle'].setValue(this.taskContent);
    var taskResponse = this.freeformagenda.updateTaskFromDialog(this.taskEdit.value,this.taskDetails.curTaskUiInfo);
    this.matDialogRef.close({taskResponse,data:'Y'});
 
  }
  onQuillReady(quill: any) {
      try {
        quill.on('text-change', () => {
          try { this.taskContent = quill.root.innerHTML; } catch {}
        });
      } catch {}
    }
}
